import * as React from 'react'
import { generatePath, useHistory } from 'react-router-dom'

import { DOC_INSIGHTS_PATH } from 'paths'
import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/readReceipt.svg'
import { Actor } from './Actor'
import Styles from 'components/ActivityEvent/ActivityEvent.module.scss'
import { ActivityEventPosition, ArticleReadReceiptRequestEvent } from './Types'

interface Props extends ActivityEventPosition {
  event: ArticleReadReceiptRequestEvent
}

const ArticleReadReceiptRequest = ({ event, ...props }: Props) => {
  const {
    user,
    data,
    article: { slug },
  } = event
  const { message } = data

  const history = useHistory()

  const openInsights = (e: React.MouseEvent) => {
    e.stopPropagation()
    history.push(generatePath(DOC_INSIGHTS_PATH, { slug }))
  }

  return (
    <BaseActivityEvent
      {...props}
      icon={<Icon />}
      timestamp={event.timestamp}
      message={message}
      content={
        <>
          <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> turned on read receipts.{' '}
          <div className={Styles.link} onClick={openInsights}>
            Open Insights
          </div>
        </>
      }
    />
  )
}

export { ArticleReadReceiptRequest }
